/**
 * WizJointExhibition 及联展示组件
 * @author jzhu
 * @date 2020-05-14
 */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'
import { modelUtils } from '@/utils'
import { framework_tool } from '@/tool'
const { WizContainer } = framework_tool

class WizJointExhibition extends WizContainer {
    componentName = 'WizJointExhibition'

    constructor(props) {
        super(props)
    }
    static propTypes = {
        type: PropTypes.oneOf(['org']),
        data: PropTypes.string,
        renderValue: PropTypes.any
    }

    _componentDidMount = () => {
        let { type, data } = this.props
        this._searchData(type, data)
    }

    propsAndStateOnChange = {
        type: this._onChange.bind(this),
        data: this._onChange.bind(this)
    }

    _onChange(nextProps, nextState) {
        let { type, data } = nextProps
        this._searchData(type, data)
        return true
    }

    _searchData(type, data) {
        if (type && data) {
            let path = ''
            if (type === 'org') {
                path = 'organization/getOrganizationInfo'
            }
          if (type === 'position') {
            path = 'position/getById'
          }
            if (path) {
                this.doAction({
                    path,
                    payload: {
                        key: 'wizJointExhibition_' + type,
                        apiParams: {
                            id: data
                        }
                    }
                })
            }
        }
    }

    _render() {
        let { type, data, value, renderValue } = this.props
        let showData = ''
        if (data) {
            if (type === 'org' || type === 'position') {
                if (value.data && value.data.code) {
                    showData = value.data.code
                }
            }
        }
        if (renderValue) {
            renderValue(value.data || {}, showData)
        }
        return (
            <div>{showData}</div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let { type } = ownProps
    let source = {}
    if (type === 'org') {
        source = state.organization
    }
  if (type === 'position') {
    source = state.position
  }
    const value = modelUtils.getModelEntity(source, 'wizJointExhibition_' + type)
    return {
        value
    }
}

export default connect(mapStateToProps)(WizJointExhibition)
